// extracted by mini-css-extract-plugin
export default {"div":"ProfileStories_div__MI9QI"};